const RACES = {
    terran: {
        name: "Terran",
        path: "sc2_ui_userprofile_ladders_race_icon_terran.png",
    },
    protoss: {
        name: "Protoss",
        path: "sc2_ui_userprofile_ladders_race_icon_protoss.png",
    },
    zerg: {
        name: "Zerg",
        path: "sc2_ui_userprofile_ladders_race_icon_zerg.png",
    },
    time: {
        name: "Time",
        path: "icon-time-protoss.png",
    },
}

export default RACES
